module.exports = __webpack_public_path__ + "img/Erika-Nuñez.ec18ca42.png";